export default "__VITE_ASSET__Be0spu1W__"